import React from 'react';
import { Box, Button, Chip, Paper, Stack, Typography } from '@mui/material';
import InitialSchoolSelector from '../shared_components/initialSchoolSelector';

const CatchmentSchoolPicker = ({
  selectedSchool,
  onSchoolChange,
  onContinue,
  checkingExistingData,
  continueLabel = 'Continue',
}) => (
  <Paper sx={{ p: 4, maxWidth: 680 }}>
    <Typography variant="h6" sx={{ mb: 3 }}>
      Select a School to Explore
    </Typography>

    <InitialSchoolSelector
      selectedSchool={selectedSchool}
      onSchoolChange={onSchoolChange}
    />

    {selectedSchool && (
      <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.50', borderRadius: 1, border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="body2" gutterBottom>
          <strong>Selected:</strong> {selectedSchool.name}
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {selectedSchool.city && (
            <Chip label={selectedSchool.city} size="small" />
          )}
          {selectedSchool.state && (
            <Chip label={selectedSchool.state} size="small" />
          )}
        </Stack>
      </Box>
    )}

    <Button
      variant="contained"
      disabled={!selectedSchool || checkingExistingData}
      onClick={onContinue}
      sx={{ mt: 3 }}
    >
      {checkingExistingData ? 'Checking for existing data…' : continueLabel}
    </Button>
  </Paper>
);

export default CatchmentSchoolPicker;
